import { render } from "./create-expense.vue?vue&type=template&id=3c294e30&scoped=true"
import script from "./create-expense.vue?vue&type=script&lang=js"
export * from "./create-expense.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./create-expense.vue?vue&type=style&index=1&id=3c294e30&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c294e30"]])

export default __exports__